"use strict";

import Vue from "vue";
import axios from "axios";
import store from "../store";
// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
let config = {
    baseURL: process.env.VUE_APP_API_URL || ""
    // timeout: 60 * 1000, // Timeout
    // withCredentials: true, // Check cross-site Access-Control
};
const _axios = axios.create(config);

_axios.interceptors.request.use(
    function(config) {
        if (window.$cookies.get("jwt"))
            config.headers.Authorization = "Bearer " + window.$cookies.get("jwt");
            config.headers['Access-Control-Allow-Origin'] = '*';
            config.headers['c9-hash'] = document.getElementsByName("c9-hash")[0].getAttribute('value');
        return config;
    },
    function(error) {
        return Promise.reject(error);
    }
);

// Add a response interceptor
_axios.interceptors.response.use(
    function(response) {
        // Do something with response data
        if (response.data && response.data.statusCode === 401) {
            store.dispatch("common/setStateTokenExpired");
        }
        return response;
    },
    function(error) {
        // Do something with response error
        // Do something with request error
        if (error.response && error.response.status === 401) {
            store.dispatch("common/setStateTokenExpired");
        } else {
            if (error.response && error.response.data && error.response.status === 500 && !error.response.data.latest_version.includes(error.response.data.request_version)) {
                store.dispatch("common/setStateShowModal", true);
            }
            store.dispatch("common/setStateErrorRequest");
        }
        return Promise.reject(error);
    }
);

Plugin.install = function(Vue) {
    Vue.axios = _axios;
    window.axios = _axios;
    Object.defineProperties(Vue.prototype, {
        axios: {
            get() {
                return _axios;
            }
        },
        $axios: {
            get() {
                return _axios;
            }
        }
    });
};

Vue.use(Plugin);

export default Plugin;
